import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/connectionsupport",

        async list() {
            return await Vue.http.get(this.url());
        },

        async create(data) {
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http
                .post(this.url(), data)
                .catch((error) => {
                    EventBus.$emit("CANCEL_SPINNER");
                    throw error;
                });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async update(data) {
            const url = this.url(`/${data.id}`);
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http.put(url, data).catch((error) => {
                EventBus.$emit("CANCEL_SPINNER");
                throw error;
            });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async remove({ id }) {
            const url = this.url(`/${id}`);
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http.delete(url).catch((error) => {
                EventBus.$emit("CANCEL_SPINNER");
                throw error;
            });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },
    },
    base
);
